import React, { useReducer, useState } from 'react';
import ElginPayService from '../services/ElginPayService';
import PrinterService from '../services/PrinterService';
import WooService from '../services/WooService';

const GlobalContext = React.createContext();

const wooService = new WooService();

const PRINTER_FAILURE = "Atenção! Impressoras não instaladas. Reinicie o app. Erro: ";

const wait = (ms) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            console.log("Done waiting");
            resolve(ms)
        }, ms);
    })
}  

const globalReducer =  (printers, action) => {
    switch (action.type) {
        case 'createInternalPrinter':
            const internalPrinterService = new PrinterService();
            internalPrinterService.sendStartConnectionPrinterIntern();
            return [...printers, { name: action.payload, printerService: internalPrinterService }];
        case 'createElginPayPrinter':
            internalPrinterService.sendStartConnectionPrinterElginPay();
            return [...printers, { name: action.payload, printerService: internalPrinterService }];
        case 'createExternalPrinter':
            const externalPrinterService = new PrinterService();
            externalPrinterService.sendStartConnectionPrinterExtern(action.payload.ipAddress, 9100);
            return [...printers, { name: action.payload.name, printerService: externalPrinterService }];
        case 'destroyPrinter':
            action.payload.printerService.printerStop();
            return printers.filter((printer) => printer.name !== action.payload);
        case 'loadPrinters':
            //let installedPrinters = [];
            //action.payload.data.forEach(printer => {
                /*
                const printerService = new PrinterService();
                if (printer.place === 'service' || printer.address === 'internal') {
                    printerService.sendStartConnectionPrinterIntern();
                    const newPrinter = {...printer, printerService: printerService};
                    installedPrinters.push(newPrinter);
                } else if (printer.type === 'tcpip') {
                    printerService.sendStartConnectionPrinterExtern(printer.address, 9100);
                    const newPrinter = {...printer, printerService: printerService};
                    installedPrinters.push(newPrinter);
                }
                */
                //if (printer.place === 'service' || printer.address === 'internal' || printer.type === 'tcpip') {
                //    installedPrinters.push(printer);
                //}
            //});
            return action.payload;
        default:
            return printers;
    }
};

const GlobalProvider = ({ children }) => {
    const [id, setId] = useState();
    const [customer, setCustomer] = useState();
    const [printers, dispatch] = useReducer(globalReducer, []);
    const [elginPayService, setElginPayService] = useState();

    const loadPrinters = async () => {
        try {
            const allPrinters = await wooService.getPrinters();
            let installedPrinters = [];
            for (printer of allPrinters.data) {
                if (['internal', 'tcpip'].includes(printer.type)) {
                    /*
                    const printerService = new PrinterService();
                    switch(printer.type) {
                        case 'internal':
                            if (isElginPay) {
                                await printerService.sendStartConnectionPrinterElginPay();
                            } else {
                                await printerService.sendStartConnectionPrinterIntern();
                            }
                            break;
                        case 'tcpip':
                            await printerService.sendStartConnectionPrinterExtern(printer.address, 9100);
                            break;
                    }                               
                    const newPrinter = {...printer, printerService: printerService};
                    installedPrinters.push(newPrinter);
                    */
                    installedPrinters.push(printer);
                }
            }
            dispatch({ type: 'loadPrinters', payload: installedPrinters });
            return installedPrinters;
        }
        catch(error) {
            console.log(PRINTER_FAILURE, error);
        }
    }

    const createInternalPrinter = (printerInfo) => {
        dispatch({ type: 'createInternalPrinter', payload: printerInfo });
    };

    const createElginPayPrinter = (printerInfo) => {
        dispatch({ type: 'createElginPayPrinter', payload: printerInfo });
    };

    const createExternalPrinter = (printerInfo) => {
        dispatch({ type: 'createExternalPrinter', payload: printerInfo });
    };
    
    const destroyPrinter = (printerName) => {
        dispatch({ type: 'destroyPrinter', payload: printerName });
    };

    const initElginPayService = () => {
        const elginPayService = new ElginPayService();
        setElginPayService(elginPayService);
    }

    return (
        <GlobalContext.Provider value={{ id, setId, customer, setCustomer, printers, loadPrinters, createInternalPrinter, createExternalPrinter, destroyPrinter, elginPayService, initElginPayService }}>
            {children}
        </GlobalContext.Provider>
    );
};

export { GlobalContext, GlobalProvider };